<template>
  <b-dropdown-form
    class="py-1 dropdown-filter-form-n"
  >
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>
    <b-form-group
      label="Section"
      @click.native.stop
    >
      <v-select
        v-model="gisMapValue"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        label="name"
        multiple
        placeholder="Select from list"
        :options="mapOptions"
        :clearable="false"
        :reduce="name => name.mapID"
      />
    </b-form-group>
    <b-form-group label="Lot Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option.code"
        v-model="statusFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Product Type">
      <b-form-checkbox
        v-for="option in productOptions"
        :key="option.code"
        v-model="productFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <b-form-group label="Lot Type">
      <b-form-checkbox
        v-for="option in lotTypeOptions"
        :key="option.code"
        v-model="lotTypeFilterValue"
        :value="option.code"
        name="flavour-3a"
      >
        {{ option.title }}
      </b-form-checkbox>
    </b-form-group>
    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BButton, BRow, BCol, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BButton,
    BDropdownForm,
    BFormGroup,
    BRow,
    BCol,
    BFormCheckbox,
    vSelect,
  },
  props: {
    product: {
      type: [Array, null],
      default: null,
    },
    productOptions: {
      type: Array,
      required: true,
    },
    status: {
      type: [Array, null],
      default: null,
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    gisMap: {
      type: [Array, null],
      default: null,
    },
    mapOptions: {
      type: Array,
      default: () => [],
    },
    lotType: {
      type: [Array, null],
      default: null,
    },
    lotTypeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      productFilterValue: JSON.parse(JSON.stringify(this.product)) || [],
      statusFilterValue: JSON.parse(JSON.stringify(this.status)) || [],
      lotTypeFilterValue: JSON.parse(JSON.stringify(this.lotType)) || [],
      gisMapValue: JSON.parse(JSON.stringify(this.gisMap)) || [],
    }
  },
  watch: {
    product: {
      immediate: true,
      handler(val) {
        this.productFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    status: {
      immediate: true,
      handler(val) {
        this.statusFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    lotType: {
      immediate: true,
      handler(val) {
        this.lotTypeFilterValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
    gisMap: {
      immediate: true,
      handler(val) {
        this.gisMapValue = JSON.parse(JSON.stringify(val)) || []
      },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:status', this.statusFilterValue)
      this.$emit('update:lotType', this.lotTypeFilterValue)
      this.$emit('update:gisMap', this.gisMapValue)

      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.productFilterValue = []
      this.statusFilterValue = []
      this.lotTypeFilterValue = []
      this.gisMapValue = []

      this.$emit('update:product', this.productFilterValue)
      this.$emit('update:status', this.statusFilterValue)
      this.$emit('update:lotType', this.lotTypeFilterValue)
      this.$emit('update:gisMap', this.gisMapValue)

      this.$emit('emitHideFilter')
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
